import { contrastRatio } from '@yola/yola-palette-generator';
import reduceColorPointByRatio from '../../../common/utils/reduce-color-point-by-ratio';
import reduceOpacity from '../../../common/utils/reduce-opacity';

const condition = (ratio) => ratio >= 2;

const dark = (params) => {
  const { infoColorPalette, backgroundColor } = params;
  const fallback = {
    rule: 'focusBorder.focus.dark',
    params,
  };
  if (condition(contrastRatio(backgroundColor, infoColorPalette[900]))) {
    return reduceOpacity({
      targetColor: infoColorPalette[900],
      backgroundColor,
      opacity: 0.99,
      condition,
      fallback,
    });
  }

  return reduceColorPointByRatio(
    {
      targetColor: infoColorPalette[900],
      backgroundColor,
      targetColorPalette: infoColorPalette,
      condition: (ratio) => ratio > 2,
      fallback,
    },
    '900'
  );
};

export default dark;
